/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apis: {
    // bludot: 'https://bludotapidev.quinns.pw/api',
    bludot: 'https://bludotapiuat.quinns.pw/api',
    // bludot: 'http://localhost:8080/api',
    BludotApiKey: 'kmdTVmpK0v5uMKhM',
    images: 'https://bludot.ams3.digitaloceanspaces.com/uat/images',
  },
  config: {
    storeid: 3, // spar titanic ordering
    currency: 'GBP',
    kioskId: 'Spar_Titanic_kiosk_2@bludot.cloud',
  },
  storage: {
    basket: 'kiosk_bskt',
    allergens: 'kiosk_allergens'
  },
  allergenList: [
    {
      id: 1,
      name: 'Celery',
      icon: 'celery',
    },
    {
      id: 2,
      name: 'Cereal',
      icon: 'gluten'
    },
    {
      id: 3,
      name: 'Crustaceans',
      icon: 'crustacean_shellfish'
    },
    {
      id: 4,
      name: 'Eggs',
      icon: 'egg'
    },
    {
      id: 5,
      name: 'Fish',
      icon: 'fish'
    },
    {
      id: 15,
      name: 'Gluten',
      icon: 'gluten'
    },
    {
      id: 6,
      name: 'Lupin',
      icon: 'lupins'
    },
    {
      id: 7,
      name: 'Milk',
      icon: 'dairy'
    },
    {
      id: 8,
      name: 'Molluscs',
      icon: 'mollusk'
    },
    {
      id: 9,
      name: 'Mustard',
      icon: 'mustard'
    },
    {
      id: 10,
      name: 'Nuts',
      icon: 'tree_nuts'
    },
    {
      id: 11,
      name: 'Peanuts',
      icon: 'peanuts'
    },
    {
      id: 12,
      name: 'Sesame',
      icon: 'sesame'
    },
    {
      id: 13,
      name: 'Soya',
      icon: 'soybeans'
    },
    {
      id: 14,
      name: 'Sulphur',
      icon: 'sulfate'
    }
  ]
};
